<section class="trust-section">

    <div class="trust-header" data-aos="fade-up" data-aos-duration="1000">
        <div class="container">
            <app-badge text="Nuestra trayectoria"></app-badge>
            <h2 class="trust-title" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">{{ title }}</h2>
            <p class="trust-subtitle" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">{{ description }}</p>
            <!-- <div class="title-accent"></div> -->
        </div>
    </div>

    <div class="brands-section" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
        <div class="container">
            <p class="brands-label">Empresas que han confiado en nosotros</p>
            <div class="brands-grid">
                @for (brand of brands; track brand.alt) {
                    <div class="brand-cell">
                        <div class="brand-logo">
                            <img [src]="brand.src" [alt]="brand.alt" width="110" height="50" loading="lazy" decoding="async" />
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

</section>
